Ext.ns('mx.comp');

mx.comp.GeoTextField = Ext.extend(Ext.form.TextField, {
    labels: {
        pointArea: 'Draw area (polygon) on map',
    },
    params: null,
    mapWindowElExists: false,
    onRender: function(ct, position) {
        mx.comp.GeoTextField.superclass.onRender.call(this, ct, position);

        this.el.dom.readOnly = true;

        this.container.addClass('mx-comp-geotextfield');
        this.el.addClass('input');
        this.geo = Ext.DomHelper.append(
            this.container.dom,
            {
                tag: 'div',
                cls: 'lookup',
            },
            true
        );

        this.geo.on(
            'click',
            function() {
                if (this.mapWindow && this.mapWindowElExists) {
                    this.mapWindow.destroy();
                    this.mapWindowElExists = false;
                }
                this.mapWindow = new mx.app.widget.GeoRegionWindow({
                    title: this.labels.pointArea,
                    formClass: mx.app.widget.PolygonForm,
                    editable: true,
                    resizable: true,
                    maximizable: true,
                    width: 650,
                    minHeight: 300,
                    initialPolyline: this.getValue(),
                    listeners: {
                        ok: {
                            fn: function(o, e) {
                                if (o.points && o.points.length > 2) {
                                    var value = o.points.join('|');
                                    this.setValue(value);
                                } else {
                                    this.setValue(null);
                                }
                                o.window.destroy();
                            },
                            scope: this,
                        },
                    },
                    formClassConfig: {
                        mapParams: new mx.comp.MapParams(this.getArguments()),
                    },
                });
                if (this.mapWindow.formClassConfig.mapParams.valid()) {
                    this.mapWindow.show();
                    this.mapWindowElExists = true;
                }
            },
            this
        );
    },

    onResize: function(w, h) {
        if (typeof w == 'number') {
            this.el.setWidth(this.adjustWidth('input', w - this.geo.getWidth()));
        }
    },
});

Ext.reg('mx-geotextfield', mx.comp.GeoTextField);
